import womencell from "../../../assets/CampuLifeImages/womencell.jpg"
import counc1 from "../../../assets/CampuLifeImages/counc1.jpg"
import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage';


const AntiRagging = () => {
  const womenCellContent = {
    pagename:"Anti-Ragging and Eve-Teasing",
    name: "antiragging",
    contentImg: counc1,
    hover: true,
    viewmore: "true",
    viewless: "true",
    title: "Anti-Ragging and Eve-Teasing Committee Activities",
    para: "An Anti-Ragging and Eve-Teasing Committee is a body formed in educational institutions to prevent and address incidents of ragging (bullying or harassment of newcomers) and eve-teasing (sexual harassment or misconduct towards women). The Cell's responsibility is to ensure that students maintain discipline in the classrooms and within the college campus.",
    paratitle: "Objectives of the Committee:",
    paratitlecontents: [{ title: "Prevention of Ragging & Eve-Teasing : ", content: "Ensuring a safe and respectful environment for students and employees." },
    { title: "Awareness Campaigns : ", content: "Conducting awareness programs about the negative impact of ragging and harassment." },
    { title: "Monitoring and Vigilance : ", content: "Keeping an eye on vulnerable areas like hostels, classrooms, and campus premises." },
    { title: "Complaint Redressal Mechanism : ", content: "Providing a safe platform for victims to report incidents without fear." },
    { title: "Strict Actions Against Offenders : ", content: "Ensuring disciplinary actions, as per legal and institutional guidelines." }
    ],
    title2: "How to Report:",
    subtitle2: "Victims or witnesses can report cases to:",
    subtitlecontents: ["Committee members via email, helpline, or complaint box.", "College administration or authorities.", "National Anti-Ragging Helpline (India) – 1800-180-5522"],
    fourhover:true
  }

  const hoverContent = [
    { img: womencell, para1: "", para2: "" },
    { img: womencell, para1: "", para2: "" },
    { img: womencell, para1: "", para2: "" },
    { img: womencell, para1: "", para2: "" }
  ]

  const tableData = [
    { title: "Anti Ragging - Eve teasing Member" },
    { headings: [{ heading1: "S.No.", heading2: "Name", heading4: "Position", heading5: "Email id" }] },
    {
      data: [{ id: 1, name: 'Dr. R. Marimuthu (Principal)', pos: "Chairman", emailId: "9486856121" },
      { id: 2, name: 'Mr. B. Sankar Gopu', pos: "Convenor", emailId: "9994793640" },
      { id: 3, name: 'Dr. S. Padmadevi', pos: "Member", emailId: "9443585511" },
      { id: 4, name: 'Mr. J. Jayaraj', pos: "Member", emailId: "9944350234" },
      { id: 5, name: 'Adv. P. Reghukumar', pos: "Member", emailId: "9442305800" },
      { id: 6, name: 'Dr. J. Babudhas', pos: "Member", emailId: "9543646823" },
      { id: 7, name: 'Mrs. N. Geetha', pos: "Member (Parent)", emailId: " " },
      { id: 8, name: 'Mr. M. Ramalingam', pos: "Member (Parent)", emailId: " " },
      { id: 9, name: 'Ms. G.S. Nikitha Sree', pos: "Member (student)", emailId: " " },
      { id: 10, name: "Mr. R. Sajin Kumar", pos: "Member (student)", emailId: " " }
      ]
    },
    { padding: true }
  ];

  return (
    <>
      <ExtenStudClubGrievPage data={womenCellContent} hoverContent={hoverContent} tableData={tableData}/>
    </>
  )
}

export default AntiRagging